<template>
    <div v-if="rows.length != undefined && rows.length > 0 && rows.length != null">
        <div class="bg-white data-table p-0">
            <vue-good-table
                ref="listAssetTable"
                mode="remote"
                title="Assets"
                @on-page-change="onPageChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: true,
                    position: 'bottom',
                    perPage: perPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
                >
            </vue-good-table>
        </div>
    </div>
    <div v-else>
        <span>No data Found</span>
    </div>
</template>


<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default ({
    components: {
        appFooter: () => import('@/components/Footer'),
    },
    props: {
        fromModule: {
            type: Object,
            required: false,
            default: undefined
        },
    },
    watch:{
        
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        columns: [
            {
                label: 'Group',
                field: 'group',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: '# Unit',
                field: 'unit',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Year',
                field: 'year',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Make',
                field: 'make',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Model',
                field: 'model',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Unit Type',
                field: 'unit_type',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Start Date',
                field: 'from_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'End Date',
                field: 'to_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Last Status Change',
                field: 'status_change_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Utilized',
                field: 'utilized',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Status',
                field: 'status',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
        ],
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            sort: {
                field: 'id',
                type: 'desc',
            },
            page: 1,
            perPage: 50
        },
        reportData:null,
        reportType:'',
    }),
    mounted: function() {
        let self = this;
        setTimeout(function () {
            self.getlistdata();
        }, 1000);
    },
    methods: {
        updateParams(newProps) { 
            if(newProps.columnFilters != undefined && newProps.columnFilters != null) {
                this.serverParams.columnFilters = newProps.columnFilters;
            }
            if(newProps.sort != undefined && newProps.sort != null) {
                this.serverParams.sort = newProps.sort;
            }
            if(newProps.page != undefined && newProps.page != null) {
                this.serverParams.page = newProps.page;
            }
            if(newProps.perPage != undefined && newProps.perPage != null) {
                this.serverParams.perPage = newProps.perPage;
            }
            if(newProps.selectedAll != undefined && newProps.selectedAll != null) {
                this.serverParams.selectedAll = newProps.selectedAll;
            }
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            if (this.firstLoad == 1){
                this.getlistdata();
            }
        },
        onPerPageChange(params) {
            let self = this;
            this.updateParams({perPage: params.currentPerPage});
            this.totalRecords = self.totalRecords;

            if( self.totalRecords < (params.currentPerPage * this.serverParams.page) ) {
                this.updateParams({page: 1});
            } else {

                this.updateParams({page: params.currentPage});
            }
            if (this.firstLoad == 1){
                this.getlistdata();
            }
        },
        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            this.getlistdata();
        },
        getlistdata(){
            let self = this;
            let selectedRows = [];
            let filterAll = self.serverParams.columnFilters;
            self.$parent.loading = true;

            if(self.fromModule!=null && self.fromModule!=undefined){
                self.reportData = self.fromModule;
                self.reportType = self.reportData.report_type.value;
            }
            let fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: filterAll,
                sort: self.serverParams.sort,
                flag: self.flag,
                action:self.action,
                selectedRows:selectedRows,
                report_data:JSON.stringify(self.reportData),
            };
            self.firstLoad = 1;

            $.ajax({
                url: process.env.ROOT_API + "/asset-reports/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        let i = 0;
                        //hide columns
                        for (let val of self.columns) {
                            if(self.reportType == 'Mean/Median/Mode'){
                                if(val.field == 'unit_type'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'status'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            } else if(self.reportType == 'Utilization Overview'){
                                if(val.field == 'year' || val.field == 'make' || val.field == 'model' || val.field == 'unit' || val.field == 'unit_type'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'from_date' || val.field == 'to_date'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            } else if(self.reportType == 'Utilization Detail'){
                                if(val.field == 'year' || val.field == 'make' || val.field == 'model' || val.field == 'unit_type'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'utilized' || val.field == 'from_date'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                                //update label name for single date filter
                                if(val.field == 'from_date'){
                                    self.$set(self.columns[i], 'label', 'Date');
                                }
                            } else if(self.reportType == 'Active Units Detail'){
                                if(val.field == 'year' || val.field == 'make' || val.field == 'model'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if (val.field == 'unit_type' || val.field == 'status_change_date' || val.field == 'status') {
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            }
                            i++;
                        }
                        
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'get-asset-list')
                }
            });
            
        },
    }
    
})
</script>



// WEBPACK FOOTER //
// src/components/dashboard/AssetList.vue